import { landingBuildVersion } from './clientVersion';

// Queue early interactions until Google's script is ready. Analytics must never
// prevent an upload or navigation, including when a blocker disables the tag.
export function landingAnalyticsAllowed() {
  if (typeof window === 'undefined') return false;
  try {
    return window.__instantTranscriberAnalyticsConsent !== false
      && window.instantTranscriberAcquisition?.analyticsAllowed?.() !== false;
  } catch { return false; }
}

export function sendLandingEvent(eventName, params = {}) {
  if (!landingAnalyticsAllowed()) return false;
  try {
    const { source, medium, campaign, ...eventParams } = params;
    const send = window.gtag || function () {
      (window.dataLayer = window.dataLayer || []).push(arguments);
    };
    send('event', eventName, {
      app_surface: 'landing',
      ...window.instantTranscriberAcquisition?.context(),
      ...eventParams,
      app_version: landingBuildVersion(),
      ...(source ? { event_source: source } : {}),
    });
    return true;
  } catch { return false; }
}

export function landingErrorParams(error) {
  try {
    if (typeof window !== 'undefined' && window.instantTranscriberDiagnostics?.describeError)
      return window.instantTranscriberDiagnostics.describeError(error, { component: 'FreeAudioTools' });
  } catch {}
  return { error_code: 'tool_processing_failed', error_component: 'FreeAudioTools' };
}
